import React from 'react';
import styled from 'styled-components';
import { BetTracker, Caesars, WilliamHill } from './logos';
import config from '../config';

export default function CompositeLogo() {
  const BrandLogo = config.BRANDING === 'WILLIAM_HILL' ? WilliamHill : Caesars;
  return (
    <Wrapper>
      <BrandLogo />
      <Divider />
      <BetTracker />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  align-items: center;
  display: flex;
`;

const Divider = styled.div`
  background-color: #000000;
  content: '';
  display: block;
  margin: 0 1rem;
  height: 33px;
  width: 1px;
`;
